import React from 'react';
import Select from '@/components/common/ReactSelect5';
import { AvailableProgram } from './useAvailablePrograms';

interface Option {
  label: string;
  value: number;
}

interface AddProgramDropdownProps {
  availablePrograms: AvailableProgram[];
  isDisabled?: boolean;
  isLoading: boolean;
  linkedProgramIds: Set<number>;
  onSelect: (program: AvailableProgram) => void;
}

const AddProgramDropdown = ({
  availablePrograms,
  isDisabled = false,
  isLoading,
  linkedProgramIds,
  onSelect,
}: AddProgramDropdownProps) => {
  const filteredPrograms = availablePrograms.filter(p => !linkedProgramIds.has(p.id));

  const options: Option[] = filteredPrograms.map(program => ({
    label: program.name,
    value: program.id,
  }));

  const handleChange = (option: Option | null) => {
    if (!option) return;

    const program = availablePrograms.find(p => p.id === option.value);
    if (program) onSelect(program);
  };

  return (
    <div className="tw-mt-4">
      <p className="tw-mb-2">
        Select a Program below to link to this auto-rostered class:
      </p>
      <div className="tw-flex tw-items-center tw-gap-12">
        <label
          className="tw-text-dark-grey tw-whitespace-nowrap tw-mb-0"
          htmlFor="addProgramSelect"
        >
          Program
        </label>
        <div className="tw-flex-1">
          <Select
            showCaret
            borderColorOverride="#aaa"
            id="addProgramSelect"
            isDisabled={isDisabled}
            isLoading={isLoading}
            menuPosition="fixed"
            noOptionsMessage={() => 'No available programs to link'}
            options={options}
            placeholder="Select a Program..."
            value={null}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default AddProgramDropdown;
